import type { CrossJoinTargetProduct } from '../../common/types';
import type { NonContextualNote, NonContextualNoteParams } from '../types';

import { nonContextualNoteMessages } from './messages';

export const buildNonContextualNote = ({
    displayName,
    userEmail,
    fullName,
    userId,
    targetProduct,
    formatMessage,
}: NonContextualNoteParams): NonContextualNote | undefined => {
    const valuePropMessage = getValueProp(targetProduct);

    if (!valuePropMessage) {
        return undefined;
    }

    const requestingUser = displayName || fullName || userEmail || userId;
    const requestingApp = getProductName(targetProduct);
    const valueProp = formatMessage(valuePropMessage);
    const noteText = formatMessage(nonContextualNoteMessages.CJNNonContextualNote, {
        requestingUser,
        requestingApp,
        valueProp,
    });
    return noteText;
};

export const getProductName = (targetProduct: CrossJoinTargetProduct): string => {
    switch (targetProduct) {
        case 'jira-product-discovery':
            return 'Jira Product Discovery';
        case 'jira-software':
            return 'Jira';
        case 'loom':
            return 'Loom';
        case 'confluence':
            return 'Confluence';
        default:
            return targetProduct;
    }
};

export const getValueProp = (targetProduct: CrossJoinTargetProduct) => {
    switch (targetProduct) {
        case 'jira-product-discovery':
            return nonContextualNoteMessages.jpdValueProp;
        case 'jira-software':
            return nonContextualNoteMessages.jiraValueProp;
        case 'loom':
            return nonContextualNoteMessages.loomValueProp;
        case 'confluence':
            return nonContextualNoteMessages.confluenceValueProp;
        default:
            return undefined;
    }
};

export { nonContextualNoteMessages } from './messages';